var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { usePopup } from "@components/common/popup/CommonPopup";
import CreatePop from "@components/dashBoard/proposal/popup/CreatePop";
import DeletePop from "@components/dashBoard/proposal/popup/DeletePop";
import SharePop from "@components/dashBoard/proposal/popup/SharePop";
import ProposalTable from "@components/dashBoard/proposal/ProposalTable";
import { SearchPop } from "@components/dashBoard/report/ReportEnable";
import { alertState, curReportState, curTotalState, mainState, reportTypeState } from "@recoil/assessmentState";
import { proposalEditState } from "@recoil/componentState";
import { loadingBoxDarkState, loadingBoxState } from "@recoil/menuState";
import { reLoad, reloadSpg, userInfoLoginState } from "@recoil/userState";
import { fileDownload, PromiseHttp, resultCheck } from "@utils/api/HttpUtil";
import { isnull, jsopen_AlertPopup, jsopen_m_Popup, onClickSelect, selectFoucs, selectOption } from "@utils/commUtils";
import { API_200, POP_ALERT, TYPE_NONE } from "@utils/Const";
import { saveToFile_Chrome } from "@utils/file/fileUtil";
import { useTrans } from "@utils/langs/useTrans";
import axios from "axios";
import dayjs from "dayjs";
import JSZip from "jszip";
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import DatePicker from "react-datepicker";
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
const AnalysisProposalView = (props) => {
    const navigate = useNavigate();
    const t = useTrans();
    const today = new Date();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTreeTotal = useRecoilValue(curTotalState);
    const setProposalData = useSetRecoilState(proposalEditState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const setRecoilIsLoadingBoxDark = useSetRecoilState(loadingBoxDarkState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [report, setReport] = useRecoilState(reportTypeState);
    const [reloadspg, setReloadspg] = useRecoilState(reloadSpg);
    const [, setReload] = useRecoilState(reLoad);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curReportState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    //props
    const { handleOpenPop, treeSel } = props;
    const [toogle, setToogle] = useState(false);
    const [treeItem, setTreeItem] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    // 페이징
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo((prev) => (Object.assign(Object.assign({}, prev), { number: page })));
    }
    // 검색
    const [searchText, setSearchText] = useState("");
    const [searchTextField, setSearchTextField] = useState("");
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "createdTime",
        sort: "desc",
    });
    const dateTermList = [
        { id: 0, dtDisp: t("라벨.직접입력"), dateFormats: "null", dtVal: 0 },
        { id: 1, dtDisp: t("라벨.T_월", ["1"]), dateFormats: "month", dtVal: 1 },
        { id: 2, dtDisp: t("라벨.T_월", ["3"]), dateFormats: "month", dtVal: 3 },
        { id: 3, dtDisp: t("라벨.T_월", ["6"]), dateFormats: "month", dtVal: 6 },
        { id: 4, dtDisp: t("라벨.T_년", ["1"]), dateFormats: "year", dtVal: 1 },
    ];
    const [startDate, setStartDate] = useState(dayjs(today)
        .set("year", dayjs(today).year() - dateTermList[4].dtVal)
        .toDate());
    const [endDate, setEndDate] = useState(today);
    const [dateSel, setDateSel] = useState(null);
    const [searchCount, setSearchCount] = useState({
        startDate: null,
        endDate: null,
    });
    const [checkItem, setCheckItem] = useState([]);
    const [checkArr, setCheckArr] = useState([]);
    const [changeTree, setChangeTree] = useState(null);
    const { openPopup, closePopup } = usePopup();
    useEffect(() => {
        // resize handler
        function handleResize() {
            if (window.innerWidth <= 940) {
                setIsMobile(true);
            }
            else {
                setIsMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        //검색
        handleOpenPop("pop-search-small", _jsx(SearchPop, { searchText: searchText, setSearchText: setSearchText, setSearchTextField: setSearchTextField }));
    }, [searchText]);
    const onClickDeletePop = () => {
        openPopup(_jsx(DeletePop, { comment: "선택한 보고서를 삭제하시겠습니까?", appPath: `proposal/`, checkItem: checkItem, setCheckItem: setCheckItem, setCheckArr: setCheckArr, handleCurPage: handleCurPage, closePopup: closePopup }));
    };
    const callSaveProposal = (zoneId, proposalType, proposalTypeId, proposalTypeName, closePopup) => __awaiter(void 0, void 0, void 0, function* () {
        const appPath = `zoneId=${zoneId}&proposalTypeId=${proposalTypeId}`;
        try {
            const res = yield PromiseHttp({
                httpMethod: "POST",
                appPath: `/proposal/data/save?${appPath}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if ((res === null || res === void 0 ? void 0 : res.codeNum) == API_200) {
                closePopup();
                setReload(false);
                setRecoilIsLoadingBoxDark(false);
                setProposalData({
                    proposalType: proposalType,
                    proposalTypeName: proposalTypeName,
                    proposalTypeId: proposalTypeId,
                    pageName: res.body.pageInfo.proposalName,
                    pageInfo: res.body.pageInfo,
                    pageSlide: res.body.pageSlide,
                });
                setReport((prev) => (Object.assign(Object.assign({}, prev), { checkType: "proposal" })));
            }
            else {
                closePopup();
                setReload(false);
                setRecoilIsLoadingBoxDark(false);
                setAlert((prev) => (Object.assign(Object.assign({}, prev), { type: TYPE_NONE, pTag: {
                        p1: `${proposalTypeName}를 생성 중 오류가 발생했습니다`,
                        p2: "베이직 및 프리미엄 분석결과 확인 후 다시 시도해 주세요.",
                    } })));
                jsopen_AlertPopup(POP_ALERT);
            }
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            closePopup();
            setReload(false);
            setRecoilIsLoadingBoxDark(false);
            setAlert((prev) => (Object.assign(Object.assign({}, prev), { type: TYPE_NONE, pTag: {
                    p1: `${proposalTypeName}를 생성 중 오류가 발생했습니다`,
                    p2: "네트워크 상태를 확인 후 다시 시도해 주세요.",
                } })));
            jsopen_AlertPopup(POP_ALERT);
        }
    });
    const onClickPublish = () => __awaiter(void 0, void 0, void 0, function* () {
        openPopup(_jsx(CreatePop, { zoneId: recoilTreeData.zoneId, proposalType: treeSel.type, proposalTypeId: treeSel.id, proposalTypeName: treeSel.name, closePopup: closePopup }));
        yield callSaveProposal(recoilTreeData.zoneId, treeSel.type, treeSel.id, treeSel.name, closePopup);
    });
    const onClickSharePop = () => {
        openPopup(_jsx(SharePop, { closePopup: closePopup, checkItem: checkItem, getMultiFileUrl: (list) => getMultiFileUrl(list) }));
    };
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/zone/filter`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: reloadspg,
    });
    useEffect(() => {
        setChangeTree(recoilTreeData);
        setRecoilIsLoadingBox(true);
        const ERR_URL = resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == API_200 && data.body.length > 0) {
                if (!recoilTreeData.companyId) {
                    let treeItem = data.body;
                    let curComapy = treeItem.filter((item) => item.zoneId == recoilState.zoneId).length > 0
                        ? treeItem.filter((item) => item.zoneId == recoilState.zoneId)[0]
                        : treeItem.filter((item) => item.companyId == recoilTreeTotal.companyId).length > 0
                            ? treeItem.filter((item) => item.companyId == recoilTreeTotal.companyId)[0]
                            : treeItem[0];
                    setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { companyId: curComapy.companyId, name: curComapy.name, zoneId: curComapy.zoneId }));
                    setRecoilState({
                        companyId: curComapy.companyId,
                        zoneId: curComapy.zoneId,
                    });
                }
                setTreeItem(data.body);
                if (reloadspg) {
                    handleCurPage(0);
                    setSortData({
                        sortField: "createdTime",
                        sort: "desc",
                    });
                    setReloadspg(false);
                }
                // 초기화
                if (changeTree && changeTree != recoilTreeData) {
                    setStartDate(dayjs(today)
                        .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                        .toDate());
                    setEndDate(today);
                    setDateSel(dateTermList[4].dtVal);
                    setSearchCount({
                        startDate: dayjs(today)
                            .set("year", dayjs(today).year() - dateTermList[4].dtVal)
                            .toDate(),
                        endDate: today,
                    });
                    handleCurPage(0);
                    setSearchText("");
                    setSearchTextField("");
                    setSortData({
                        sortField: "createdTime",
                        sort: "desc",
                    });
                    setCheckItem([]);
                    setCheckArr([]);
                }
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlert(Object.assign(Object.assign({}, alert), { layerId: "reset", type: TYPE_NONE, divTag: t("라벨.현재사업장이없어서운영관리화면으로이동합니다") }));
                jsopen_AlertPopup(POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, searchCount, reloadspg, changeTree]);
    // 사업장
    function ZoneClick(item) {
        setRecoilTreeData(Object.assign(Object.assign({}, recoilTreeData), { companyId: item.companyId, name: item.name, zoneId: item.zoneId }));
        setRecoilState({
            companyId: item.companyId,
            zoneId: item.zoneId,
        });
        setChangeTree(item);
        setToogle(false);
    }
    // 날짜 기간조회
    function handleDayPop(days) {
        if (days.dateFormats == "year") {
            setStartDate(dayjs(today)
                .set("year", dayjs(today).year() - days.dtVal)
                .toDate());
            setEndDate(today);
            setSearchCount({
                startDate: dayjs(today)
                    .set("year", dayjs(today).year() - days.dtVal)
                    .toDate(),
                endDate: today,
            });
        }
        else if (days.dateFormats == "month") {
            setStartDate(dayjs(today)
                .set("month", dayjs(today).month() - days.dtVal)
                .toDate());
            setEndDate(today);
            setSearchCount({
                startDate: dayjs(today)
                    .set("month", dayjs(today).month() - days.dtVal)
                    .toDate(),
                endDate: today,
            });
        }
        else {
            setStartDate(null);
            setEndDate(null);
        }
        setDateSel(days.id);
        handleCurPage(0);
    }
    //조회 클릭
    function onClickSearchFilter() {
        if (!startDate && endDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: TYPE_NONE, divTag: "시작 일자를 입력하세요" }));
            jsopen_AlertPopup(POP_ALERT);
        }
        else if (!endDate && startDate) {
            setAlert(Object.assign(Object.assign({}, alert), { type: TYPE_NONE, divTag: "종료 일자를 입력하세요" }));
            jsopen_AlertPopup(POP_ALERT);
        }
        else {
            handleCurPage(0);
            setSearchCount({
                startDate: startDate,
                endDate: endDate,
            });
        }
    }
    // 검색 버튼 이벤트
    function goSearch(e) {
        const schDiv = document.getElementById("mcheck_searchinput");
        const isSchMobile = schDiv.clientHeight <= 0 && schDiv.clientWidth <= 0 ? true : false;
        if (!isSchMobile) {
            setSearchTextField(searchText);
        }
        else {
            jsopen_m_Popup(e);
        }
        handleCurPage(0);
    }
    // 엔터 검색
    function searchEnter(e) {
        if (e.key == "Enter") {
            goSearch(e);
        }
    }
    function MobileToogle(e) {
        if (!toogle) {
            setToogle(true);
        }
        else {
            setToogle(false);
        }
    }
    const zoneOpen = (e) => {
        onClickSelect(e, selectOption);
        selectFoucs(recoilTreeData.zoneId, { num: 0 });
    };
    // 트리 이외 다른곳 닫기
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isBtn = targetElement.classList.contains("select__toggleBtn") || targetElement.closest(".select__toggleBtn");
            if (isBtn) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select__toggleBtn");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
                setToogle(false);
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    const columns = [
        { header: "보고서명", accessor: "proposalName", className: "sm-w45p" },
        { header: "발행일자", accessor: "createdTime", className: "w100 d-sm-w76" },
        { header: "분석기간", accessor: "peroid", className: "m-none" },
    ];
    const [tableData, setTableData] = useState([]);
    const [listReloadKey, setListReloadKey] = useState(0);
    //리스트 재조회
    useEffect(() => {
        if (reloadspg) {
            setListReloadKey((prev) => prev + 1);
        }
    }, [reloadspg]);
    let appPath = `zoneId=${recoilTreeData.zoneId}&proposalType=${treeSel.type}`;
    appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    if (!isnull(searchCount.startDate) && !isnull(searchCount.endDate)) {
        appPath =
            appPath +
                `&startDate=${dayjs(searchCount.startDate).format("YYYYMMDD")}` +
                `&endDate=${dayjs(searchCount.endDate).format("YYYYMMDD")}`;
    }
    // 검색 필드
    if (searchTextField.length > 0) {
        appPath = appPath + `&search=${searchTextField}`;
    }
    //목록 API
    const getProposalData = () => __awaiter(void 0, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: "GET",
            appPath: `/proposals?${appPath}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
            watch: appPath + reloadspg + pageInfo,
        }).then((res) => {
            if (res.codeNum == API_200) {
                setTableData(res.body.map((item) => ({
                    id: item.id,
                    name: item.proposalName,
                    date: item.createdTime,
                    period: item.period,
                })));
                setPageInfo(Object.assign(Object.assign({}, res.data.page), { listReload: false })); //5, 10; //5, 10
            }
        });
    });
    useEffect(() => {
        if (recoilTreeData.zoneId === "")
            return;
        let isMounted = true;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            try {
                yield getProposalData();
            }
            finally {
                if (isMounted)
                    setRecoilIsLoadingBox(false);
            }
        }))();
        return () => {
            isMounted = false;
        };
    }, [
        recoilTreeData.zoneId,
        listReloadKey,
        searchTextField,
        searchCount.startDate,
        searchCount.endDate,
        pageInfo.number,
        pageInfo.size,
        sortData.sortField,
        sortData.sort,
    ]);
    const onClickColunm = (list) => () => __awaiter(void 0, void 0, void 0, function* () {
        if (isMobile)
            return;
        yield PromiseHttp({
            httpMethod: "GET",
            appPath: `/proposal/detail?proposalId=${list.id}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        }).then((res) => {
            if (res.codeNum == API_200) {
                setProposalData({
                    proposalTypeId: treeSel.id,
                    proposalType: treeSel.type,
                    proposalTypeName: treeSel.name,
                    pageName: list.name,
                    pageInfo: res.body.pageInfo,
                    pageSlide: res.body.pageSlide,
                });
                setReport(Object.assign(Object.assign({}, report), { checkType: "proposal" }));
            }
        });
    });
    const handleZipDownload = () => __awaiter(void 0, void 0, void 0, function* () {
        if (checkArr.length < 2) {
            checkItem.map((list, idx) => __awaiter(void 0, void 0, void 0, function* () {
                yield PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/proposal/${list.id}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                }).then((res) => {
                    fileDownload(list.name + ".pptx", res.body.proposalFileUrl);
                });
            }));
        }
        else {
            let zipList = [];
            let zips = new JSZip();
            let zipCnt = 0;
            const zipFileName = `${recoilTreeData.name}_${dayjs(new Date()).format("YYYY-MM-DD")}.zip`;
            checkItem.map((list, idx) => __awaiter(void 0, void 0, void 0, function* () {
                yield getMultiFileUrl(list)
                    .then((val) => {
                    if (val.codeNum === 200) {
                        zipList = zipList.concat({
                            fileName: `${list.name}_${dayjs(list.date).format("HH:mm:ss")}.pptx`,
                            fileLink: val.body.proposalFileUrl,
                        });
                    }
                    return {
                        codeNum: val.codeNum,
                        fileName: `${list.name}_${dayjs(list.date).format("HH:mm:ss")}.pptx`,
                        fileLink: val.body.proposalFileUrl,
                    };
                })
                    .then((val) => {
                    if (val.codeNum === 200) {
                        axios({
                            method: "GET",
                            url: val.fileLink,
                            responseType: "blob",
                        })
                            .then((resp) => {
                            zips.file(val.fileName, resp.data);
                            zipCnt++;
                            return zipCnt;
                        })
                            .then((zipCnt) => {
                            if (zipCnt === checkItem.length) {
                                zips.generateAsync({ type: "blob" }).then(function (blob) {
                                    saveToFile_Chrome(zipFileName, blob); // 공유 연결시 해당 부분 변경
                                });
                            }
                        });
                    }
                });
            }));
        }
        setCheckItem([]);
        setCheckArr([]);
    });
    const getMultiFileUrl = (list) => __awaiter(void 0, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: "GET",
            appPath: `/proposal/${list.id}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        return data;
    });
    return (_jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsxs("div", Object.assign({ className: "box__header brd-bottom-0 gap-16" }, { children: [_jsx("div", Object.assign({ className: "m-none" }, { children: _jsxs("div", Object.assign({ className: "select", onClick: (e) => zoneOpen(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTreeData.name })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: treeItem &&
                                        treeItem.map((item, idx) => (_jsxs("li", Object.assign({ className: `option ${recoilTreeData.zoneId == item.zoneId ? "active" : ""}`, id: item.zoneId, onClick: (e) => ZoneClick(item), title: item.name }, { children: [item.name, " "] }), "userTree_" + idx.toString()))) })] })) })), _jsx("div", Object.assign({ className: `select__toggleBtn ${toogle ? "active" : ""} `, onClick: (e) => MobileToogle(e) }, { children: _jsx("p", { children: recoilTreeData.name }) })), _jsx("div", Object.assign({ className: "box selectbar menutype" }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: treeItem &&
                                    treeItem.map((item, idx) => (_jsx("li", Object.assign({ className: `${recoilTreeData.zoneId == item.zoneId ? "on" : ""}`, id: "m" + item.zoneId, onClick: (e) => ZoneClick(item) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("p", { children: item.name }) })) }), "userTree_M" + idx.toString()))) })) })) })), _jsx("div", Object.assign({ className: "tbl__top mb-0 m-none" }, { children: _jsx("div", Object.assign({ className: "select report" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-sky js-open", "data-pop": "pop-01", onClick: () => onClickPublish() }, { children: _jsxs("span", { children: ["\uC2E0\uADDC ", treeSel.name, " \uC0DD\uC131"] }) })) })) }))] })), _jsxs("div", Object.assign({ className: `box__body pt-32 ${pageInfo.totalElements == 0 ? "nodata" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "tbl__top gap-12" }, { children: [_jsx("div", Object.assign({ className: "left" }, { children: _jsx("div", Object.assign({ className: "search" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", Object.assign({ className: "flex-row center gap-24" }, { children: [_jsx("span", Object.assign({ className: "wmin-64" }, { children: _jsx("strong", { children: "\uC870\uD68C \uAE30\uAC04" }) })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "searchterm" }, { children: [_jsxs("div", Object.assign({ className: "select term__month", onClick: (e) => onClickSelect(e, selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected w100" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: !reloadspg ? dateTermList[4].dtDisp : t("라벨.직접입력") })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: dateTermList.map((dt, idx) => (_jsx("li", Object.assign({ id: "date_" + dt.id, className: "option", onClick: () => handleDayPop(dt) }, { children: dt.dtDisp }), `dt_${idx.toString()}`))) })] })), dateSel == 0 && (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "term__date" }, { children: [_jsx(DatePicker, { className: "calendar", todayButton: "today", dateFormat: "yyyy-MM-dd", selected: startDate, maxDate: endDate ? endDate : new Date(), onChange: (date) => setStartDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false }), _jsx("span", Object.assign({ className: "centerline" }, { children: "~" })), _jsx(DatePicker, { className: "calendar", todayButton: "today", dateFormat: "yyyy-MM-dd", selected: endDate, minDate: startDate, maxDate: new Date(), onChange: (date) => setEndDate(date), onFocus: (e) => (e.target.readOnly = true), readOnly: dateSel != 0 ? true : false })] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray ml-8", onClick: () => onClickSearchFilter() }, { children: _jsx("span", { children: t("라벨.조회") }) }))] })), dateSel != 0 && (_jsxs("div", Object.assign({ className: "term__date line" }, { children: [dayjs(startDate).format("YYYY-MM-DD"), " ~ ", dayjs(endDate).format("YYYY-MM-DD")] })))] })) }))] })) })) })) })), _jsx("div", Object.assign({ className: "right ml-auto" }, { children: _jsxs("div", Object.assign({ className: "btn__wrap" }, { children: [_jsxs("div", Object.assign({ className: "searcharea m-none" }, { children: [_jsx("div", Object.assign({ className: "searchinput", id: "mcheck_searchinput" }, { children: _jsxs("div", Object.assign({ className: "input__direct w200" }, { children: [_jsx("input", { type: "text", placeholder: "보고서명을 입력해주세요", value: searchText, onKeyDown: (e) => searchEnter(e), onChange: (e) => setSearchText(e.target.value) }), searchText && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete", onClick: () => setSearchText("") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC785\uB825 \uCC3D \uB2EB\uAE30" })) })))] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-gray", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) }))] })), _jsxs("div", Object.assign({ className: "flex-row center gap-8 m-none" }, { children: [_jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn btn-share-bg ml-0 tooltip-link white  op-1 m-none", "data-pop": "pop-share", onClick: (e) => onClickSharePop(), "data-tooltip": "\uACF5\uC720" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.공유") })) })), _jsx("button", Object.assign({ type: "button", disabled: checkItem.length <= 0 ? true : false, className: "btn btn-delete-bg ml-0 js-open tooltip-link white  op-1 m-none", "data-pop": "pop-delete", onClick: () => onClickDeletePop(), "data-tooltip": "\uC0AD\uC81C" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.삭제") })) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn btn-filedown ml-0 tooltip-link white  op-1 m-none w140p", onClick: () => handleZipDownload(), "data-tooltip": "\uB2E4\uC6B4\uB85C\uB4DC" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.다운로드") })) }))] })), _jsxs("div", Object.assign({ className: "m-flex gap-8" }, { children: [_jsx("div", Object.assign({ className: "searcharea m-block" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic btn-search bg-blue js-open", "data-pop": "pop-search-small", onClick: (e) => goSearch(e) }, { children: _jsx("span", { children: t("라벨.검색") }) })) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic btn-share-bg tooltip-link white", "data-pop": "pop-share", onClick: (e) => onClickSharePop(), "data-tooltip": "\uACF5\uC720" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.공유") })) })), _jsx("button", Object.assign({ type: "button", disabled: checkItem.length <= 0 ? true : false, className: "btn-basic btn-delete-bg js-open tooltip-link white", "data-pop": "pop-delete", onClick: () => onClickDeletePop(), "data-tooltip": "\uC0AD\uC81C" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.삭제") })) })), _jsx("button", Object.assign({ disabled: checkArr.length <= 0 ? true : false, type: "button", className: "btn-basic btn-filedown tooltip-link white op-1 w140p", onClick: () => handleZipDownload(), "data-tooltip": "\uB2E4\uC6B4\uB85C\uB4DC" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.다운로드") })) }))] }))] })) }))] })), tableData.length == 0 ? (_jsx("div", Object.assign({ className: "tab-cont-wrap part-len nodata" }, { children: _jsxs("p", Object.assign({ className: "nodata__txt" }, { children: ["\uC0DD\uC131\uB41C \uBD84\uC11D \uBCF4\uACE0\uC11C\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. ", _jsx("br", {}), "\uC2E0\uADDC \uC0DD\uC131\uD574\uC8FC\uC138\uC694."] })) }))) : (_jsx(ProposalTable, { sortData: sortData, setSortData: setSortData, pageInfo: pageInfo, handleCurPage: handleCurPage, checkItem: checkItem, setCheckArr: setCheckArr, checkArr: checkArr, setCheckItem: setCheckItem, columns: columns, tableData: tableData, pageName: treeSel.type, onClickColunm: onClickColunm }))] }))] })));
};
export default AnalysisProposalView;
